import { calcBlockHeight, formatText, usePreloaderFont } from '@rst/libs-ts'
import { PreloaderLine, useContainerWidth } from '../../atoms'
import React from 'react'
import styled from 'styled-components'

export const CardDeskPreload = (data: any) => {
	const containerWidth = useContainerWidth()

	const descr = formatText(data.text)
	const heightTitle = calcBlockHeight(
		data.title,
		usePreloaderFont(data),
		data.title_size,
		110,
		window.innerWidth < 1128 ? window.innerWidth - 165 : containerWidth,
		data
	)
	const heightSubtitle = calcBlockHeight(
		data.subtitle,
		usePreloaderFont(data),
		22,
		132,
		window.innerWidth < 1128 ? window.innerWidth - 165 : containerWidth,
		data
	)
	return (
		<Main>
			<Header>
				<PreloaderLine height={heightTitle} />
				<PreloaderLine height={heightSubtitle} />
			</Header>
			<Content>
				<Desc>
					{descr.map((x: { tag: string; text: any }, i: any) =>
						x.tag === 'ulArr' ? (
							<UlWrapp>
								{x.text.map((z: any) => (
									<PreloadSubTitle
										{...data}
										{...z}
										containerWidth={containerWidth}
									/>
								))}
							</UlWrapp>
						) : (
							<AnotherTag>
								<PreloadSubTitle
									{...data}
									{...x}
									containerWidth={containerWidth}
									key={i}
								/>
							</AnotherTag>
						)
					)}
				</Desc>
				{data.image && (
					<Img>
						<PreloaderLine />
					</Img>
				)}
			</Content>
		</Main>
	)
}

const PreloadSubTitle = ({ containerWidth, ...data }: any) => {
	const heightDescription = calcBlockHeight(
		data.text,
		usePreloaderFont(data),
		16,
		123,
		window.innerWidth < 1128 ? window.innerWidth - 165 : containerWidth,
		data
	)

	return <PreloaderLine height={heightDescription} />
}

const Desc = styled.div`
	margin-bottom: 32px;
	& > div {
		width: 100%;
	}
`

const UlWrapp = styled.div`
	margin-bottom: 24px;
	display: flex;
	gap: 8px;
	flex-direction: column;

	& > div {
		width: 100%;
	}
`

const Img = styled.div`
	aspect-ratio: 1.260947392 / 1;
	flex-grow: 1;
`

const AnotherTag = styled.div`
	margin-bottom: 16px;
`

const Header = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 40px;
`

const Content = styled.div`
	display: flex;
	flex-direction: column;
`

const Main = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 48px 40px 24px 40px;
`
